import React, { useEffect, useState } from 'react';
import ProductCategoryModel from './models/ProductCategoryModel';
import ProductCategoryDetailsFields from './ProductCategoryDetailsFields';

function AddProductCategory({ sendDataToParent, onLoad }) {
  const [formData, setFormData] = useState(new ProductCategoryModel());
  const [slugManual, setSlugManual] = useState(false);

  useEffect(() => {
    const initial = new ProductCategoryModel();
    if (onLoad) onLoad(initial);
    if (sendDataToParent) sendDataToParent(initial);
  }, []);

  const handleData = (data) => {
    setFormData(data);
    if (sendDataToParent) sendDataToParent(data);
  };

  return (
    <div className="card-body px-0">
      <ProductCategoryDetailsFields
        formData={formData}
        sendDataToParent={handleData}
        slugManual={slugManual}
        onSlugManualChange={setSlugManual}
      />
    </div>
  );
}

export default AddProductCategory;
